import {CreateItemReviewRequest, ItemReview, ItemReviewDTO, UpdateItemReviewRequest} from "../chatbot/api-types";
import {ApiFunction, ChatbotApi} from "../chatbot/towersChatbotApi";

export class SquadflixReviewsApi {
    static async submitReview(body: CreateItemReviewRequest) {
        const fn = new ApiFunction('createItemReview', ChatbotApi.baseUrl);
        return fn.call(body);
    }

    static async updateReview(body: UpdateItemReviewRequest) {
        const fn = new ApiFunction('updateItemReview', ChatbotApi.baseUrl);
        return fn.call(body);
    }

    static async getById(id: number): Promise<{ result: ItemReviewDTO }> {
        const fn = new ApiFunction('getItemReviewById', ChatbotApi.baseUrl);
        return fn.call({id});
    }

    static async find(body: Partial<ItemReview>): Promise<{ results: ItemReviewDTO[] }> {
        const fn = new ApiFunction('findItemReviews', ChatbotApi.baseUrl);
        return fn.call(body);
    }
}
